// extracted by mini-css-extract-plugin
export var button = "SearchComponentTemplate-module--button--2b018";
export var buttons = "SearchComponentTemplate-module--buttons--d130b";